import {
    useEffect,
    useState
} from 'react';
import { Platform } from 'react-native';

import actions, { navigate } from '../../actions';
import {
    Button,
    FlatList,
    Image,
    React,
    View,
    withState
} from '../../common';
import {
    fileExists,
    replaceToFullPath,
    resolveImagePath,
    tryShowImageFromCache
} from '../../services/device';
import { attachments as styles } from './style';

const checkFileExists = async (file) => {
    return fileExists(file);
};
const ListItemTitle = withState(
    ({
        item: {
            uri,
            path,
            cachePath,
            id,
        },
        onPress,
        retryRender,
        errorOccurred,
        setState,
        item,
    }) => {
        const [ resolvedUri, setResolvedUri ] = useState();


        useEffect(() => {
            const pp = Platform.OS === 'ios' ? path || cachePath : cachePath || path;
            const res = resolveImagePath(uri, pp);
            checkFileExists(path)
                .then((r) => {
                    if (r) {
                        setResolvedUri(path);
                    } else {
                        setResolvedUri(res);
                    }
                });
        }, [ path,
            cachePath,
            uri ]);

        return (
            <Button
                action={onPress}
                styles={[ styles.addAttachmentButton, styles.attachmentsListItem ]}
                trackingId={'view_attachment_visit'}
            >
                <Image
                    key={`${id}-${retryRender ? 1 : 0}`}
                    accessibilityLabel="visits_attachments-list_image"
                    resizeMode="cover"
                    style={[ styles.attachmentPreview, !uri || errorOccurred ? styles.emptyImage : {} ]}
                    source={{ uri: resolvedUri }}
                    onError={(e) => {
                        actions.addLog('attachmentsError', {
                            resolvedPath: resolvedUri,
                            uri,
                            path,
                            cachePath,
                            id,
                            item,
                            e,
                        });
                        tryShowImageFromCache(
                            path,
                            item,
                            uri,
                            () => setState({ retryRender: !retryRender }),
                            (err) => {
                                setState({ errorOccurred: true });

                                actions.addLog('attachmentsErrorCache', {
                                    uri,
                                    path,
                                    cachePath,
                                    id,
                                    item,
                                    err,
                                });
                            },
                        );
                    }}
                />
            </Button>
        );
    },
);

const checkImageData = async (data) => {
    const res = [];
    const isIos = Platform.OS === 'ios';

    if (!isIos) {
        return data;
    }

    for (const item of data) {
        const {
            uri,
            path,
            cachePath,
        } = item;

        if (!uri) {
            res.push(item);
            continue;
        }

        const p = Platform.OS === 'ios' ? path || cachePath : cachePath || path;
        console.log('checkImageData', {
            p,
            uri,
        });
        const currentPath = resolveImagePath(uri, p);
        const exists = await fileExists(currentPath);
        if (exists) {
            res.push(item);
            continue;
        }

        // Если файл не найден, пробуем переключиться между temp и documents папками
        let alternativePath = null;
        const localPath = resolveImagePath(uri, path);

        if (localPath?.startsWith('~/tmp')) {
            // Если файл в temp папке, пробуем documents
            alternativePath = localPath.replace('~/tmp', '~/Documents');
        } else if (localPath?.startsWith('~/Documents')) {
            // Если файл в documents папке, пробуем temp
            alternativePath = localPath?.replace('~/Documents', '~/tmp');
        }

        if (alternativePath) {
            const alternativeFullPath = replaceToFullPath(alternativePath);
            const alternativeExists = await fileExists(alternativeFullPath);

            if (alternativeExists) {
                // Файл найден в альтернативной папке, обновляем path
                let newPath;

                if (alternativePath?.startsWith('~/tmp')) {
                    // Переключаемся на temp папку
                    newPath = path?.replace(/\/Documents\//, '/tmp/');
                } else if (alternativePath?.startsWith('~/Documents')) {
                    // Переключаемся на documents папку
                    newPath = path?.replace(/\/tmp\//, '/Documents/');
                }

                res.push({
                    ...item,
                    path: newPath || path,
                });
            } else {
                // Файл не найден ни в одной из папок
                res.push(item);
            }
        } else {
            // Не удалось определить альтернативный путь
            res.push(item);
        }
    }
    return res;
};

export const Attachments = ({
    data: srcData,
    manualVisit,
    readOnly,
    clickable = true,
}) => {
    const [ data, setData ] = React.useState(srcData || []);

    useEffect(() => {
        checkImageData(srcData)
            .then((images) => {
                setData(images);
            })
            .catch(() => {
                setData(srcData);
            });

    }, [ srcData, setData ]);

    return (
        <View
            accessibilityLabel="visits_attachments-section"
            style={[
                styles.containerBottom,
                {
                    marginHorizontal: 10,
                    marginBottom: 0,
                    paddingBottom: 0,
                },
            ]}
        >
            {!!data && (
                <FlatList
                    accessibilityLabel="visits_attachments-list"
                    horizontal
                    data={data}
                    renderItem={({
                        item: { id },
                        item,
                    }) => (
                        <ListItemTitle
                            item={item}
                            onPress={() =>
                                !!clickable &&
                                navigate('VisitImagesSlider', {
                                    initialId: id,
                                    enableDelete: true,
                                    manualVisit,
                                    readOnly,
                                })
                            }
                        />
                    )}
                />
            )}
        </View>
    );
};
